<div *ngIf="certificateVM$ | async as certificate"
     class="certificate-item">
  <ng-container *ngIf="!loadingFailedText; else loadingFailed">
    <div class="sections-wrapper">
      <section class="media">
        <ling-media-slider
          [media]="certificate.general?.images"
          [loginProcessMessage]="loginProcessMessage"
          [videoActive]="true"
        ></ling-media-slider>
      </section>
      <section *ngIf="certificate.general as generalInfo"
               class="general-info">
        <h3 class="general-info__name">{{ generalInfo.productTitle }}</h3>
        <p *ngIf="generalInfo.productCreator as creator"
           class="general-info__creator">
              by {{ creator }}
        </p>
        <p class="general-info__description">{{ generalInfo.productDescription }}</p>
      </section>
      <section *ngIf="certificate.keyMetrics"
               class="key-metrics">
        <ng-container *ngFor="let item of certificate.keyMetrics">
          <div class="key-metrics__item">
            <div *ngIf="item.cardType === 'circle'; else digit"
                 class="key-metrics__spinner">
              <mat-progress-spinner
                mode="determinate"
                [strokeWidth]="15"
                [value]="item.value">
              </mat-progress-spinner>
              <p class="key-metrics__spinner__value">{{ item.value }}</p>
            </div>

            <ng-template #digit>
              <p class="key-metrics__numeric">{{ item.value }}</p>
            </ng-template>

            <p class="key-metrics__label">{{ item.label }}</p>
          </div>
        </ng-container>
      </section>
    </div>
    <section class="dynamic-sections">
      <mat-accordion multi>
        <mat-expansion-panel *ngFor="let section of certificate.dynamicSections; let i = index"
                             [expanded]="i === 0">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined" color="primary">{{ section.sectionIcon }}</mat-icon>
            <mat-panel-title>{{ section.sectionName }}</mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let item of section.contentItems">
            <ng-container [ngSwitch]="item.contentType">
              <ng-container *ngSwitchCase="certificateDynamicSectionContentType.SimpleText">
                <ng-container *ngTemplateOutlet="simpleText; context: {$implicit: item.simpleText}"></ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="certificateDynamicSectionContentType.Markdown">
                <ng-container *ngTemplateOutlet="markdown; context: {$implicit: item.markdown}"></ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="certificateDynamicSectionContentType.ProgressBar">
                <ng-container *ngTemplateOutlet="progressBar; context: {$implicit: item.progressBar}"></ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="certificateDynamicSectionContentType.SimpleList">
                <ng-container *ngTemplateOutlet="simpleList; context: {$implicit: item.simpleList}"></ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="certificateDynamicSectionContentType.ComplexList">
                <ng-container *ngTemplateOutlet="complexList; context: {$implicit: item.complexList}"></ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="certificate.certificateOfAuthenticityView">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined" color="primary">shield</mat-icon>
            <mat-panel-title> Certificate of Authenticity</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="certificate-authenticity-fields-wrapper">
            <div>
              <span class="certificate-authenticity__key">{{ certificate.general?.productTitle }} - </span>
              <span class="certificate-authenticity__token">
              <ng-container *ngIf="certificate.token as token; else notMinted">
                ID: {{ token }}
              </ng-container>
              <ng-template #notMinted>
                not minted
              </ng-template>
            </span>
            </div>
            <div>
              <span class="certificate-authenticity__key">Issued by : </span>
              <span *ngIf="certificate.status === certificateStatus.Created; else minted">
              Not minted
            </span>
              <ng-template #minted>
              <span>{{ certificate.general?.productCreator }}
                <ng-container *ngIf="certificate.issued as issued">- {{ issued | date : 'yyyy-MM-dd' }}*</ng-container>
              </span>
              </ng-template>
            </div>
          </div>
          <ng-container *ngIf="certificate?.status === certificateStatus.Released; else notReleased">
            <a
              class="certificate-authenticity__claim-certificate"
              [href]="certificate.claimLink"
            >
              <span>{{ "certificatePreviewPage.claim.buttonText" | translate }}</span>
            </a>
          </ng-container>
          <ng-template #notReleased>
            <p class="certificate-authenticity__certificate-status">
              <ng-container *ngIf="certificate?.status === certificateStatus.Created">Not minted</ng-container>
              <ng-container *ngIf="certificate?.status === certificateStatus.Minted">Not released</ng-container>
              <ng-container *ngIf="certificate?.status === certificateStatus.Claimed">Certificates is claimed
              </ng-container>
            </p>
          </ng-template>
          <button
            *ngIf="certificate && certificate.status === certificateStatus.Claimed"
            class="certificate-authenticity__certificate-history-button"
            type="button"
            mat-flat-button
            color="primary"
            (click)="dialog.openCertificateHistoryDialog(certificate!)"
          >
            <span class="certificate-authenticity__certificate-history-button__content">
              {{ "certificatePreviewPage.historyButton" | translate }}
              <mat-icon>history</mat-icon>
            </span>
          </button>

          <div *ngIf="certificate.issued"
               class="certificate-authenticity__clarification">
            <span class="key">*Blockchain: </span>
            <span>Data is decentrally stored on the Chromia Blockchain. Ownership can be released & transferred
            by the current owner of the certificate.</span>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="certificate.companyDetails as cd">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined" color="primary">business</mat-icon>
            <mat-panel-title>{{ 'certificateView.companyProfile' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="company-facility-details company-facility-details__block">
            <p class="company-facility-details__line"><strong>{{ cd.legalCompanyName }}</strong></p>
            <p class="company-facility-details__line">{{ cd.registeredAddress }}</p>
            <p class="company-facility-details__line">{{ cd.dppContactEmail }}</p>
            <p class="company-facility-details__line">{{ 'certificateView.manufacturerId' | translate }}: {{ cd.uniqueManufacturerId }}</p>
            <p class="company-facility-details__line">{{ 'certificateView.countryOfRegistration' | translate }}: {{ cd.countryOfRegistration }}</p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="certificate.facilityDetails as fd">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined" color="primary">factory</mat-icon>
            <mat-panel-title>{{ 'certificateView.manufacturingFacility' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="company-facility-details company-facility-details__block">
            <p class="company-facility-details__line"><strong>{{ fd.facilityName }}</strong>
              <span class="company-facility-details__muted"> ({{ fd.facilityId }})</span></p>
            <p class="company-facility-details__line">{{ 'certificateView.countryOfManufacture' | translate }}: {{ fd.countryOfManufacturer }}</p>
            <p class="company-facility-details__line">{{ fd.fullAddress }}</p>
            <p *ngIf="fd.isPrimary" class="company-facility-details__badge">{{ 'certificateView.primaryFacility' | translate }}</p>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="certificate.buttons?.length">
          <mat-expansion-panel-header>
            <mat-icon class="material-icons-outlined" color="primary">smart_button</mat-icon>
            <mat-panel-title> Additional info</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="certificate-buttons">
            <a
              *ngFor="let button of certificate.buttons"
              class="certificate-buttons__button"
              mat-flat-button
              color="primary"
              [href]="getCertificateButtonUrl(button)"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ button.label }}
            </a>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </section>
    <section *ngIf="!(routerEventsService.isPreviewPage$ | async)"
             class="certificate-link">
      <qrcode
        style="width: 150px; cursor: pointer"
        matTooltip="{{ 'dialogs.release.qrCodeTooltip' | translate }}"
        [matTooltipPosition]="'above'"
        [qrdata]="getCertificatePreviewLink(certificate)!"
        elementType="svg"
        [cssClass]="'qr-styles'"
        (click)="copyImage(qrUrl)"
        [width]="150"
      ></qrcode>
      <qrcode
        hidden
        [qrdata]="getCertificatePreviewLink(certificate)!"
        elementType="img"
        (qrCodeURL)="qrUrl = $event"
        [width]="500"
      ></qrcode>
      <span class="copy-link" (click)="copyLink(certificate._id!, 'snackbar.success.urlCopied')">
      Copy certificate link
    </span>
      <div *ngIf="(isOwner$ | async) && !liveMode && !isPublicPreview" class="certificate-link__guest-edit">
        <ng-container *ngIf="draftForCertificate$ | async as draft; else noGuestDraft">
          <ng-container *ngIf="draft.draftStatus === 'active'; else noGuestDraft">
            <span class="copy-link" (click)="copyGuestLink(draft)">
              {{ 'guestEdit.copyGuestLink' | translate }}
            </span>
            <button mat-button type="button" (click)="dialog.closeCurrent(undefined); router.navigate(getReviewChangesRoute(certificate._id!), { queryParams: getReviewChangesQueryParams(draft._id) })">
              {{ 'guestEdit.reviewChanges' | translate }}
            </button>
          </ng-container>
        </ng-container>
        <ng-template #noGuestDraft>
          <span class="copy-link" (click)="generateAndCopyGuestLink(certificate)">
            {{ 'guestEdit.generateLink' | translate }}
          </span>
        </ng-template>
      </div>
    </section>
  </ng-container>
  <div class="loading-overlay" *ngIf="initialLoading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <ng-template #loadingFailed>
    <p class="loading-failed" *ngIf="loadingFailedText">
      {{ loadingFailedText }}
    </p>
  </ng-template>
</div>

<ng-template #simpleText let-text>
  <p *ngIf="text"
     class="text">{{ text }}</p>
</ng-template>

<ng-template #markdown let-markdown>
  <div *ngIf="markdown"
       class="marked-up-text" [innerHTML]="sanitizeMarkdownHtml(markdown)"></div>
</ng-template>

<ng-template #progressBar let-progressBar>
  <div *ngIf="progressBar"
       class="progress-bar">
    <p class="progress-bar__title">{{ progressBar.title }}</p>
    <mat-progress-bar mode="determinate" [value]="progressBar.value"></mat-progress-bar>
    <div class="progress-bar__details">
      <span>Origin: {{ progressBar.origin }}</span>
      <span>{{ progressBar.value + ' ' + progressBar.text }}</span>
    </div>
  </div>
</ng-template>

<ng-template #simpleList let-simpleList>
  <div *ngIf="simpleList"
       class="simple-list">
    <ng-container *ngFor="let section of simpleList">
      <h4>{{ section.title }}</h4>
      <div class="simple-list__grid"
           [class.simple-list__grid__horizontal]="section.rowDirection === simpleListRowDirections.Horizontal">
        <ng-container *ngFor="let item of section.items">
          <p class="list-item">
            <span class="list__item__key">{{ item.key + ': ' }}</span>
            <span>{{ item.value }}{{ item.unit?.unit ? ' ' + item.unit.unit : '' }}</span>
          </p>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #complexList let-complexList>
  <div *ngIf="complexList?.length"
       class="complex-list">
    <div *ngFor="let listSection of complexList"
         class="complex-list__section">
      <h3>{{ listSection.title }}</h3>
      <div *ngFor="let subSection of listSection.subSections"
           class="complex-list__subsection">
        <h4>{{ subSection.subSectionTitle }}</h4>
        <ng-container *ngFor="let field of subSection.fields">
          <a *ngIf="field.link; else listItem"
             [href]="field.link"
             class="list__item__link">
            <mat-icon color="primary" [svgIcon]="certificateLinksIcons[asLingAttributeIconKey(field.iconKey)]"></mat-icon>
            <span>{{ field.link }}</span>
          </a>
          <ng-template #listItem>
            <p class="list__item">
              <span class="list__item__key">{{ field.key + ': '}}</span>
              <span>{{ field.value }}{{ field.unit?.unit ? ' ' + field.unit.unit : '' }}</span>
            </p>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
